import React, { useState, useEffect } from 'react';
import HelpTogal from '../TogelButton/HelpTogal';
import AddonsServices from '../../services/AddonsServices';

function AddonsUpdate({ addons, closeModal, onSuccess }) {
  const [formValues, setFormValues] = useState({
    title: '',
    price: '',
    minutes: '',
    image: '',
  });
  const [previewImage, setPreviewImage] = useState('img/placeholder-img.png'); // Placeholder image path

  useEffect(() => {
    if (addons) {
      setFormValues({
        title: addons?.title || '',
        price: addons?.price || '',
        minutes: addons?.minutes || '',
        image: addons?.image || '',


      });
      if (addons.image) {
        setPreviewImage(process.env.REACT_APP_URL + addons.image);
      }
    }
  }, [addons]);

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormValues({
      ...formValues,
      [name]: value,
    });
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setPreviewImage(reader.result);
      };
      reader.readAsDataURL(file);
      setFormValues({
        ...formValues,
        image: file,
      });
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    try {
      const formData = new FormData();
      for (const key in formValues) {
        if (key !== 'image' || formValues[key] instanceof File) {
          formData.append(key, formValues[key]);
        }
      }

      await AddonsServices.updateAddons(addons.id, formData);
      alert('Addons updated successfully');
      onSuccess();
      closeModal();
    } catch (error) {
      console.error('Failed to update addons', error);
      alert('Failed to update addons');
    }
  };

  return (
    <div className="modal fade edit-box show d-block" id="editModal" tabIndex={-1} aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title"> Edit Addons</h5>
            <button type="button" className="btn-close" data-bs-dismiss="modal" onClick={closeModal} aria-label="Close" />
          </div>
          <div className="modal-body">
            <div className="container-box px-5">
              <div className="container-box-inner">
                <div className="page-details">
                  <form onSubmit={handleSubmit}>
                    <div className="row">
                      <div className="col-lg-12 col-sm-12">
                        <div className="input-field">
                          <label>Title</label>
                          <input type="text" name="title" className="form-control" value={formValues.title} onChange={handleInputChange} placeholder="Title" />
                        </div>
                      </div>
                      <div className="col-lg-12 col-sm-12">
                        <div className="input-field">
                          <label>Price</label>
                          <input type="number" name="price" className="form-control" value={formValues.price} onChange={handleInputChange} placeholder="Price" min="0"
                            step="0.01"
                          />
                        </div>
                      </div>

                      <div className='col-lg-12 col-sm-12' >
                        <div className="input-field">
                          <label>Minutes</label>
                          <input type="number" name="minutes" value={formValues.minutes}
                            onChange={handleInputChange} defaultValue="Product scanning" className="form-control" />
                        </div>
                      </div>


                      <div className="col-sm-12">
                        <div className="input-field">
                          <label>Upload<span className="red">*</span></label>
                          <input type="file" name="image" className="form-control" onChange={handleFileChange} />
                          <p><span>Drop an image or Paste URL (up to resolution 1,500 x 1,500 px),</span> Supported formats: png, jpeg, jpg, webp</p>
                          <div className="file-preview text-center">
                            <img id="uploadFile" src={previewImage} alt="your image" />
                          </div>
                        </div>
                      </div>

                    </div>
                    <button className="submit-green-btn">Submit</button>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AddonsUpdate;
